import React from "react";
import { Plus, Trash2 } from "lucide-react";
import ImageUploader from "./ImageUploader";

// Manages an array of { image, caption } pairs.
const CaptionedImagesUploader = ({ items = [], onChange, label, captionPlaceholder = "Caption (italic, optional)", aspect = "aspect-[4/3]" }) => {
  const update = (idx, patch) => {
    const next = [...items];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  const remove = (idx) => onChange(items.filter((_, i) => i !== idx));
  const add = () => onChange([...items, { image: "", caption: "" }]);
  return (
    <div>
      {label && (
        <div className="text-xs font-medium uppercase tracking-wider text-[color:var(--muted)] mb-3">
          {label}
        </div>
      )}
      <div className="space-y-5">
        {items.map((it, i) => (
          <div key={i} className="p-4 rounded-xl border border-black/10 bg-[color:var(--bg-2)]/40">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs uppercase tracking-wider text-[color:var(--muted)]">
                Item {i + 1}
              </span>
              <button
                type="button"
                onClick={() => remove(i)}
                className="text-xs text-[color:var(--coral)] hover:underline inline-flex items-center gap-1"
              >
                <Trash2 className="w-3.5 h-3.5" /> Remove
              </button>
            </div>
            <ImageUploader
              label=""
              value={it.image}
              onChange={(v) => update(i, { image: v })}
              aspect={aspect}
            />
            <input
              value={it.caption || ""}
              onChange={(e) => update(i, { caption: e.target.value })}
              placeholder={captionPlaceholder}
              className="mt-3 w-full bg-transparent border-b border-black/15 focus:border-[color:var(--coral)] outline-none py-2 text-sm italic transition-colors"
            />
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={add}
        className="mt-3 inline-flex items-center gap-1.5 text-sm text-[color:var(--coral)] hover:underline"
      >
        <Plus className="w-4 h-4" /> Add image
      </button>
    </div>
  );
};

export default CaptionedImagesUploader;
